import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { decryptAES256, DecryptOrderFunction, EncryptOrderFun, stackDecrypt } from '../features/CryptoJsService'
import { commonUriAll } from '../CommonUrlList/CommonUrlList'
import { openLoginModal } from '../features/ModalSlice'

export const CommonHeader = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const SessionUser = (sessionStorage.getItem("userData") && (sessionStorage.getItem("userData")))
    const balanceData = useSelector(state => state?.balanceState?.balanceData)
    const [changePassDetail, setChangePassDetail] = useState({
        cPass: "",
        nPass: ""
    })

    const homeMaster = useSelector(state => state.homeMaster?.master)

    const dateFormater = (date, separator, day) => {
        var day = date.getDate()
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return year + separator + month + separator + day;
    }

    const timeFormate = (date) => {
        var day = date.getHours()
        var month = date.getMinutes();
        var year = date.getSeconds();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return day + ":" + month + ":" + year;
    }

    const [data, setData] = useState({
        eid: "",
        link: " "
    })

    const changeData = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const addTvLink = async () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "eventId": data.eid,
            "link": data.link
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        const res2 = await fetch('https://hh.fun4club.com/api/slb/slbupload', requestOptions)
        const data3 = await res2.json()
        if (data3.success) {
            toast.success("Link added successfully")
        } else {
            toast.error("Error: Link is not added")
        }
    }

    const [bookData, setBookData] = useState({
        eid: "",
        link: "",
        cockie: ""
    })

    const changeBookData = (e) => {
        setBookData({
            ...bookData,
            [e.target.name]: e.target.value
        })
    }

    const addBookId = async () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "mid": bookData.eid,
            "bkid": bookData.link
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        const res2 = await fetch('https://hh.fun4club.com/api/bookmaker/addbookid', requestOptions)
        const data3 = await res2.json()
        setBookData({
            eid: "",
            link: ""
        })
        if (data3.success) {
            toast.success("MarketId Added successfully")
        } else {
            toast.error("Error: MarketId is not added")
        }
    }

    const addFullBook = async () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "cockiee": bookData.cockie,
            "mid": bookData.eid,
            "key": bookData.link,
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        const res2 = await fetch('https://hh.fun4club.com/api/bookmaker/addbookmaker', requestOptions)
        const data3 = await res2.json()
        setBookData({
            eid: "",
            link: ""
        })
        if (data3.success) {
            toast.success("BookMaker Added successfully")
        } else {
            toast.error("Error: BookMaker is not added")
        }
    }

    const deleteBookId = async () => {
        const res2 = await fetch('https://hh.fun4club.com/api/bookmaker/deletebookid?mid=' + bookData.eid)
        const data3 = await res2.json()
        // setBookData({
        //     eid: "",
        //     link: ""
        // })
        if (data3.success) {
            toast.success("MarketId deleted successfully")
        } else {
            toast.error("Error: MarketId is not deleted")
        }
    }

    const [resultData, setResultData] = useState({
        mid: "",
    })

    const onResultDChange = (e) => {
        setResultData({ ...resultData, [e.target.name]: e.target.value })
    }

    const [activeExp, setActiveExp] = useState()
    const [btn, setBtn] = useState({
        btn1: 0,
        btn2: 0,
        btn3: 0,
        btn4: 0,
        btn5: 0,
        btn6: 0,
    })

    const openSideBar = () => {
        const sidebarId = document.getElementById("sidebar")
        if (sidebarId.classList.contains("active")) {
            sidebarId.classList.remove("active")
        } else {
            sidebarId.classList.add("active")
        }
        sidebarId.classList.contains("active")
    }

    const logoutUser = async () => {
        toast.success("You have logged out 😔", {
            theme: "green",
            icon: '😔'
        })
       
        // localStorage.clear()
        sessionStorage.clear()
        // logOut()
        navigate('/')
        navigate(0)
    }

    const rollBackMidHero = async (mid) => {
        const res = await fetch('https://webapi.demoxyzapi.com/api/v1/result/rollbackmarket?mid=' + mid)
        const data = await res.json()
        return data
    }
    const rollBackMidShree = async (mid) => {
        const res = await fetch('https://postresultapi.9xxbet.com/api/admin/RollBack?mid=' + mid)
        const data = await res.json()
        return data
    }

    const rollBackMidParker = async (mid) => {
        const res = await fetch('https://postresultparker.fun4club.com/api/admin/RollBack?mid=' + mid)
        const data = await res.json()
        return data
    }

    const rollBackMidFox = async (mid) => {
        const res = await fetch('https://postresult.fun4club.com/api/admin/RollBack?mid=' + mid)
        const data = await res.json()
        return data
    }

    const rollBackMidMaster = async (mid) => {
        const res = await fetch('https://masterpg.9xxbet.com/api/v1/result/rollbackmarket?mid=' + mid)
        const data = await res.json()
        return data
    }

    const rollBackMongo = async (mid) => {
        const res = await fetch('https://nodebb.radhe99.com/api/rollback?mid=' + mid)
        const data = await res.json()
        return data
    }

    const rollBackVelki = async (mid) => {
        const res = await fetch('https://postresultapivelki.9xxbet.com/api/admin/RollBack?mid=' + mid)
        const data = await res.json()
        return data
    }

    const rollBackMidAll = async (mid) => {
        if (window.confirm("Are you sure you want to rollBack this marketId = " + mid)) {
            if (window.confirm("Please Confirm again rollBack marketId = " + mid)) {
                rollBackMongo(mid)
                rollBackVelki(mid)
                rollBackMidFox(mid)
                rollBackMidMaster(mid)
                rollBackMidParker(mid)
                rollBackMidShree(mid)
                return
            }
        }
    }

    const getBtnStack2 = async () => {
        const token = SessionUser.Message;
        let __POSTDATA =
        {
            'AUT': token.split('_')[1],
            "ID": SessionUser.UserId
        }
        let __HASH = EncryptOrderFun(JSON.stringify(__POSTDATA));
        const res = await fetch(commonUriAll.__Get_Stack_Btn + "?Data=" + encodeURIComponent(__HASH.toString()), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        })
        const data = await res.json()
        const decrypted = stackDecrypt(data)
        setBtn(prev => ({
            ...prev,
            btn1: parseInt(decrypted.split(",")[0]),
            btn2: parseInt(decrypted.split(",")[1]),
            btn3: parseInt(decrypted.split(",")[2]),
            btn4: parseInt(decrypted.split(",")[3]),
            btn5: parseInt(decrypted.split(",")[4]),
            btn6: parseInt(decrypted.split(",")[5]),
        })
        )
    }

    const getUserExpozure = async () => {
        const token = SessionUser.Message;
        let __POSTDATA =
        {
            AUT: token.split('_')[1],
            UID: SessionUser.UserId
        }
        let __HASH = EncryptOrderFun(JSON.stringify(__POSTDATA));
        const res = await fetch(commonUriAll.__GetUserExpozure + "?Data=" + encodeURIComponent(__HASH.toString()), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        })
        const data = await res.json()
        const decrypted = await DecryptOrderFunction(data)
        setActiveExp(decrypted)
    }

    const addExEventID = () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "exid": document.getElementById('exidadd').value
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://hh.fun4club.com/api/fancy/addexid", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success === true) {
                    toast.success("Key added successfully")
                } else {
                    toast.error("Key is not aded")
                }
            })
            .catch(error => console.log('error', error));
    }

    const addExEventIDElection = () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "exid": document.getElementById('exideladd').value
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://hh.fun4club.com/api/fancy/addelectionexid", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success === true) {
                    toast.success("Key added successfully")
                } else {
                    toast.error("Key is not aded")
                }
            })
            .catch(error => console.log('error', error));
    }

    const removeExId = () => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "exid": document.getElementById('exidremove').value
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://hh.fun4club.com/api/fancy/removeexid", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.success === true) {
                    toast.success("Key removed successfully")
                } else {
                    toast.error("Key is not removed")
                }
            })
            .catch(error => console.log('error', error));
    }

    const [cbtfFancyList, setCbtfFancyList] = useState()
    const [inpEvd, setInpEvd] = useState('')

    const getCbtfFancy = async (exid) => {
        const res = await fetch(`https://nodebb.radhe99.com/api/fancy/getwinnerfancy?eid=${exid}`)
        const data = await res.json()
        console.log(data)
        setCbtfFancyList(data.data.data);
    }

    const addCbtfFancy = (element) => {
        //var randomID = makeRandom(3);
        const type = document.getElementById('ftype_' + element.exMarketId).value
        if (type === "0") {
            toast.error("Please select market type")
        } else {
            const addto = []
            const mainObject = {
                "btMarketStatus": 0,
                "dtStartDate": dateFormater(new Date(), "-") + " " + timeFormate(new Date()),
                // "dtStartDate": new Date(element.marketTime).toLocaleString(),
                "stCompititionID": (element.eventId).toString(),
                "stCompititionName": type,
                "stEventID": (element.eventId).toString(),
                "stEventName": element.eventName,
                "stMarketID": element.exMarketId,
                "stMarketName": element.marketName,
                "stSportsID": "12",
                "stSportsName": "Fancy_" + type,
                "submaster": [
                    {
                        stInstrumentID: element.exMarketId + "_StackRange",
                        stMarketID: element.exMarketId,
                        stRunnerName: "1-2500000",
                        stSelectionID: "StackRange"
                    }
                ]
            }
            addto.push(mainObject)
            const raw = JSON.stringify(addto);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status) {
                        toast.success("Market added to our server park.")
                    } else {
                        toast.error("Market is not added")
                    }
                })
                .catch(error => {
                    toast.error("Server Error 500")
                    console.log('error', error)
                });
        }
    }

    const getApiFancyList = async () => {
        const res = await fetch(`https://api.baazibox.com/api/v1/master/specialmaster`)
        const data = await res.json()
        setCbtfFancyList({ data: data.data });
    }

    const [radhefancy, setradhefancy] = useState()
    const getApiFancyListRadhe = async (eid, tk) => {
        const res = await fetch(`https://masterpg.9xxbet.com/api/v1/master/getradhemaster?eid=${eid}&tk=${tk}`)
        const data = await res.json()
        setradhefancy(data)
    }

    useEffect(() => {
        // getApiFancyList()
        // let a = setInterval(() => {
        //     getApiFancyList()
        // }, 5000);
        // return () => {
        //     clearInterval(a)
        // }
    }, [])

    const addFancyApi = async (element) => {
        const eventId = document.getElementById('exid9').value
        // if (type === "0") {
        //     toast.error("Please select market type")
        // } else {
        const addto = []
        const mainObject = {
            "btMarketStatus": 0,
            "dtStartDate": dateFormater(new Date(), "-") + " " + timeFormate(new Date()),
            // "dtStartDate": new Date(element.marketTime).toLocaleString(),
            "stCompititionID": 0,
            "stCompititionName": 'Fancy',
            "stEventID": eventId,
            "stEventName": element.eventName,
            "stMarketID": element.marketId,
            "stMarketName": element.name,
            "stSportsID": "0",
            "stSportsName": "Fancy_" + element.competitionName,
            "submaster": [
                {
                    stInstrumentID: "2.124" + element.marketId + "_StackRange",
                    stMarketID: "2.124" + element.marketId,
                    stRunnerName: "1-2500000",
                    stSelectionID: "StackRange"
                }
            ]
        }

        const mainObj2 = {
            bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: 0, eventId: eventId, eventTypeId: "0", inplay: true, key: "FANCY",
            marketId: element.marketId, marketName: element.name, marketStatus: "OPEN", marketSuspendTime: new Date(), marketTime: new Date(), marketType: "Fancy_" + "FM", numberOfRunners: 0,
            productType: "EXCHANGE", runners: null, totalAvailable: 0, totalMatched: 0, eventName: element.eventName, competitionName: 'FM', eventTypeName: "Fancy"
        }
        addto.push(mainObject)
        const raw = JSON.stringify(addto);
        const raw2 = JSON.stringify(mainObj2);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        var requestOptions2 = {
            method: 'POST',
            headers: myHeaders,
            body: raw2,
            redirect: 'follow'
        };

        fetch("https://webapi.demoxyzapi.com/api/v1/master/addmaster", requestOptions2)
            .then(response => response.json())
            .then(result => {
                if (result.status === 'success') {
                    toast.success("Market added to our postg server.")
                } else {
                    toast.error("Market is not added")
                }
            })
            .catch(error => {
                toast.error("Server Error 500")
                console.log('error', error)
            });

        fetch("https://masterpg.9xxbet.com/api/v1/master/addmaster", requestOptions2)
            .then(response => response.json())
            .then(result => {
                if (result.status === 'success') {
                    toast.success("Market added to our mastrpg server.")
                } else {
                    toast.error("Market is not added")
                }
            })
            .catch(error => {
                toast.error("Server Error 500")
                console.log('error', error)
            });

        // fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
        //     .then(response => response.json())
        //     .then(result => {
        //         if (result.status) {
        //             toast.success("Market added to our server park.")
        //         } else {
        //             toast.error("Market is not added")
        //         }
        //     })
        //     .catch(error => {
        //         toast.error("Server Error 500")
        //         console.log('error', error)
        //     });
        // }
    }
    const addFancyApiradhe = async (element) => {
        const type = document.getElementById('radheftype_' + element.fancyId).value
        if (type === "0") {
            toast.error("Please select market type")
        } else {
            const addto = []
            const mainObject = {
                "btMarketStatus": 0,
                "dtStartDate": dateFormater(new Date(), "-") + " " + timeFormate(new Date()),
                // "dtStartDate": new Date(element.marketTime).toLocaleString(),
                "stCompititionID": element.tournament.id,
                "stCompititionName": type,
                "stEventID": element.match.id,
                "stEventName": element.match.name,
                "stMarketID": "2.124" + element.fancyId,
                "stMarketName": element.fancyName,
                "stSportsID": "0",
                "stSportsName": "Fancy_" + type,
                "submaster": [
                    {
                        stInstrumentID: "2.124" + element.fancyId + "_StackRange",
                        stMarketID: "2.124" + element.fancyId,
                        stRunnerName: "1-2500000",
                        stSelectionID: "StackRange"
                    }
                ]
            }

            const mainObj2 = {
                bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: element.tournament.id, eventId: element.match.id, eventTypeId: "0", inplay: true, key: "FANCY",
                marketId: "2.124" + element.fancyId, marketName: element.fancyName, marketStatus: "OPEN", marketSuspendTime: new Date(), marketTime: new Date(), marketType: "Fancy_" + type, numberOfRunners: 0,
                productType: "EXCHANGE", runners: null, totalAvailable: 0, totalMatched: 0, eventName: element.match.name, competitionName: type, eventTypeName: "Fancy"
            }
            addto.push(mainObject)
            const raw = JSON.stringify(addto);
            const raw2 = JSON.stringify(mainObj2);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            var requestOptions2 = {
                method: 'POST',
                headers: myHeaders,
                body: raw2,
                redirect: 'follow'
            };

            fetch("https://webapi.demoxyzapi.com/api/v1/master/addmaster", requestOptions2)
                .then(response => response.json())
                .then(result => {
                    if (result.status === 'success') {
                        toast.success("Market added to our postg server.")
                    } else {
                        toast.error("Market is not added")
                    }
                })
                .catch(error => {
                    toast.error("Server Error 500")
                    console.log('error', error)
                });

            fetch("https://masterpg.9xxbet.com/api/v1/master/addmaster", requestOptions2)
                .then(response => response.json())
                .then(result => {
                    if (result.status === 'success') {
                        toast.success("Market added to our mastrpg server.")
                    } else {
                        toast.error("Market is not added")
                    }
                })
                .catch(error => {
                    toast.error("Server Error 500")
                    console.log('error', error)
                });

            fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status) {
                        toast.success("Market added to our server park.")
                    } else {
                        toast.error("Market is not added")
                    }
                })
                .catch(error => {
                    toast.error("Server Error 500")
                    console.log('error', error)
                });
        }
    }

    const [addFancyModal, setAddFancyModal] = useState({
        marketname: "",
        markettype: "",
        eventId: "",
        eventName: ""
    })

    const selectChange = (e) => {
        setAddFancyModal({
            ...addFancyModal, markettype: e.target.value
        })
    }

    const onMChange = (e) => {
        setAddFancyModal({
            ...addFancyModal, [e.target.name]: e.target.value
        })
    }

    const makeRandom = (lengthOfCode = Number) => {
        let possible = "1234567890";
        let text = "";
        for (let i = 0; i < lengthOfCode; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }

    const addMarketToDataBase = async (element) => {
        var randomID = makeRandom(3);
        const addto = []
        const mainObj2 = {
            bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: addFancyModal.eventId, eventId: (addFancyModal.eventId).toString(), eventTypeId: 0, inplay: true, key: "MARKET:" + "2.11" + randomID + addFancyModal.eventId,
            marketId: "2.11" + randomID + addFancyModal.eventId, marketName: addFancyModal.marketname, marketStatus: 'OPEN', marketSuspendTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketType: addFancyModal.markettype, numberOfRunners: 0,
            productType: "EXCHANGE", runners: [], totalAvailable: 0, totalMatched: 0, eventName: addFancyModal.eventName, competitionName: addFancyModal.markettype, eventTypeName: "Fancy"
        }
        const resp = await fetch("https://webapi.demoxyzapi.com/api/v1/master/addmaster", {
            method: "POST",
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(mainObj2)
        })
        const respdata = await resp.json()
        if (respdata.status === 'success') {
            toast.success("Market added to our server postgrey.")
        } else {
            toast.error(respdata.message)
        }
        const mainObject = {
            "btMarketStatus": 0,
            "dtStartDate": dateFormater(new Date(), "-") + " " + timeFormate(new Date()),
            // "dtStartDate": new Date(element.marketTime).toLocaleString(),
            "stCompititionID": addFancyModal.eventId,
            "stCompititionName": addFancyModal.markettype,
            "stEventID": (addFancyModal.eventId).toString(),
            "stEventName": addFancyModal.eventName,
            "stMarketID": "2.11" + randomID + addFancyModal.eventId,
            "stMarketName": addFancyModal.marketname,
            "stSportsID": "12",
            "stSportsName": "Fancy_" + addFancyModal.markettype,
            "submaster": [
                {
                    stInstrumentID: "2.11" + randomID + addFancyModal.eventId + "_StackRange",
                    stMarketID: "2.11" + randomID + addFancyModal.eventId,
                    stRunnerName: "1-2500000",
                    stSelectionID: "StackRange"
                }
            ]
        }
        addto.push(mainObject)
        const raw = JSON.stringify(addto);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status) {
                    toast.success("Market added to our server park.")
                } else {
                    toast.error("Market is not added")
                }
            })
            .catch(error => {
                toast.error("Server Error 500")
                console.log('error', error)
            });
    }

    const [winnerMarkets, setWinnerMarkets] = useState()

    const getWinnerList = async (id) => {
        const res = await fetch('https://nodebb.radhe99.com/api/bookmaker/winner?id=' + id)
        const data = await res.json()
        setWinnerMarkets(data)
    }

    const addWinnerBookMaker = async (data) => {
        const eventIdd1 = document.getElementById("winner" + data.betfairId).value
        if (eventIdd1 === "" || eventIdd1 === undefined) {
            toast.error('Please enter eventID')
        } else {
            const mainObj2 = {
                bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: '1456985632', eventId: eventIdd1, eventTypeId: 13, inplay: true, key: "MARKET:" + data.betfairId.split("#bookmaker")[0] + data.betfairId.split("#bookmaker")[1],
                marketId: data.betfairId.split("#bookmaker")[0] + data.betfairId.split("#bookmaker")[1], marketName: data.name, marketStatus: 'OPEN', marketSuspendTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketType: "BOOKMAKER", numberOfRunners: data.runners.length,
                productType: "EXCHANGE", runners: [], totalAvailable: 0, totalMatched: 0, eventName: data.eventName, competitionName: "BookMaker", eventTypeName: "Manual"
            }
            const mainObject = {
                "btMarketStatus": 0,
                "dtStartDate": dateFormater(new Date(), "-") + " " + timeFormate(new Date()),
                // "dtStartDate": new Date(element.marketTime).toLocaleString(),
                "stCompititionID": '1456985632',
                "stCompititionName": "BookMaker",
                "stEventID": eventIdd1,
                "stEventName": data.eventName,
                "stMarketID": data.betfairId.split("#bookmaker")[0] + data.betfairId.split("#bookmaker")[1],
                "stMarketName": data.name,
                "stSportsID": "13",
                "stSportsName": "Manual",
                "submaster": []
            }
            for (let i = 0; i < data.runners.length; i++) {
                const element = data.runners[i];
                const subMas = {
                    stInstrumentID: data.betfairId.split("#bookmaker")[0] + data.betfairId.split("#bookmaker")[1] + "_" + (i + 1),
                    stMarketID: data.betfairId.split("#bookmaker")[0] + data.betfairId.split("#bookmaker")[1],
                    stRunnerName: element.name,
                    stSelectionID: (i + 1).toString()
                }
                const subM2 = {
                    stInstrumentID: data.betfairId.split("#bookmaker")[0] + data.betfairId.split("#bookmaker")[1] + "_" + (i + 1),
                    marketId: data.betfairId.split("#bookmaker")[0] + data.betfairId.split("#bookmaker")[1],
                    runnerName: element.name,
                    selectionId: (i + 1)
                }
                mainObject.submaster.push(subMas)
                mainObj2.runners.push(subM2)
            }
            const resp = await fetch("https://webapi.demoxyzapi.com/api/v1/master/addmaster", {
                method: "POST",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(mainObj2)
            })
            const respdata = await resp.json()
            if (respdata.status === 'success') {
                toast.success("Market added to our server postgrey.")
            } else {
                toast.error(respdata.message)
            }
            const addto = []
            addto.push(mainObject)
            const raw = JSON.stringify(addto);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status) {
                        toast.success("Market added to our server park.")
                    } else {
                        toast.error("Market is not added")
                    }
                })
                .catch(error => {
                    toast.error("Server Error 500")
                    console.log('error', error)
                });
        }
    }

    const addSkySportBookMaker = async () => {
        const eid = document.getElementById('bookskyid')?.value
        if (!eid) {
            toast.error("Please enter eid")
        } else {
            const res = await fetch('https://nodebb.radhe99.com/api/bookmaker/sky' + "?eventId=" + eid)
            const data = await res.json()
            const mainObj2 = {
                bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: '1589634', eventId: data.bookMakerEvent.eventId.toString(), eventTypeId: 13, inplay: true, key: "MARKET:" + "1.99" + data.bookMakerMarket.markets[0].marketId,
                marketId: "1.99" + data.bookMakerMarket.markets[0].marketId, marketName: data.bookMakerMarket.markets[0].marketName, marketStatus: 'OPEN', marketSuspendTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketType: "BOOKMAKER", numberOfRunners: data.bookMakerSelection.selections.length,
                productType: "EXCHANGE", runners: [], totalAvailable: 0, totalMatched: 0, eventName: data.bookMakerEvent.eventName, competitionName: "BookMaker", eventTypeName: "Manual"
            }
            const mainObject = {
                "btMarketStatus": 0,
                "dtStartDate": dateFormater(new Date(), "-") + " " + timeFormate(new Date()),
                // "dtStartDate": new Date(element.marketTime).toLocaleString(),
                "stCompititionID": '1589634',
                "stCompititionName": "BookMaker",
                "stEventID": data.bookMakerEvent.eventId.toString(),
                "stEventName": data.bookMakerEvent.eventName,
                "stMarketID": "1.99" + data.bookMakerMarket.markets[0].marketId,
                "stMarketName": data.bookMakerMarket.markets[0].marketName,
                "stSportsID": "13",
                "stSportsName": "Manual",
                "submaster": []
            }

            for (let i = 0; i < data.bookMakerSelection.selections.length; i++) {
                const element = data.bookMakerSelection.selections[i];
                const subMas = {
                    stInstrumentID: "1.99" + data.bookMakerMarket.markets[0].marketId + "_" + element.selectionId,
                    stMarketID: "1.99" + data.bookMakerMarket.markets[0].marketId,
                    stRunnerName: element.runnerName,
                    stSelectionID: element.selectionId
                }
                const subMas2 = {
                    stInstrumentID: "1.99" + data.bookMakerMarket.markets[0].marketId + "_" + element.selectionId,
                    marketId: "1.99" + data.bookMakerMarket.markets[0].marketId,
                    runnerName: element.runnerName,
                    selectionId: element.selectionId
                }
                mainObject.submaster.push(subMas)
                mainObj2.runners.push(subMas2)
            }
            const resp = await fetch("https://webapi.demoxyzapi.com/api/v1/master/addmaster", {
                method: "POST",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(mainObj2)
            })
            const respdata = await resp.json()
            if (respdata.status === 'success') {
                toast.success("Market added to our server postgrey.")
            } else {
                toast.error(respdata.message)
            }
            const addto = []
            addto.push(mainObject)
            const raw = JSON.stringify(addto);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status) {
                        toast.success("Market added to our server park.")
                    } else {
                        toast.error("Market is not added")
                    }
                })
                .catch(error => {
                    toast.error("Server Error 500")
                    console.log('error', error)
                });
        }
    }

    const getWinnerListP = async (id) => {
        const res = await fetch('https://nodebb.radhe99.com/api/bookmaker/pwinner?id=' + id)
        const data = await res.json()
        setWinnerMarkets(data)
    }

    const addWinnerBookMakerP = async (data) => {
        const eventIdd1 = document.getElementById("exwidp").value
        if (eventIdd1 === "" || eventIdd1 === undefined) {
            toast.error('Please enter eventID')
        } else {
            const mainObj2 = {
                bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: '1458963214', eventId: eventIdd1, eventTypeId: 13, inplay: true, key: "MARKET:" + data.marketId,
                marketId: "1.99" + data.marketId, marketName: data.name === "Match Odds" ? "BOOKMAKER" : data.name, marketStatus: 'OPEN', marketSuspendTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketTime: dateFormater(new Date(), "-") + " " + timeFormate(new Date()), marketType: "BOOKMAKER", numberOfRunners: data.runner.length,
                productType: "EXCHANGE", runners: [], totalAvailable: 0, totalMatched: 0, eventName: data.eventName, competitionName: "BookMaker", eventTypeName: "Manual"
            }
            const mainObject = {
                "btMarketStatus": 0,
                "dtStartDate": dateFormater(new Date(), "-") + " " + timeFormate(new Date()),
                // "dtStartDate": new Date(element.marketTime).toLocaleString(),
                "stCompititionID": '1458963214',
                "stCompititionName": "BookMaker",
                "stEventID": eventIdd1,
                "stEventName": data.eventName,
                "stMarketID": "1.99" + data.marketId,
                "stMarketName": data.name === "Match Odds" ? "BOOKMAKER" : data.name,
                "stSportsID": "13",
                "stSportsName": "Manual",
                "submaster": []
            }
            for (let i = 0; i < data.runner.length; i++) {
                const element = data.runner[i];
                const subMas = {
                    stInstrumentID: "1.99" + data.marketId + "_" + element.id,
                    stMarketID: "1.99" + data.marketId,
                    stRunnerName: element.name,
                    stSelectionID: element.id.toString()
                }
                const subM2 = {
                    stInstrumentID: "1.99" + data.marketId + "_" + element.id,
                    marketId: "1.99" + data.marketId,
                    runnerName: element.name,
                    selectionId: element.id
                }
                mainObject.submaster.push(subMas)
                mainObj2.runners.push(subM2)
            }
            const resp = await fetch("https://webapi.demoxyzapi.com/api/v1/master/addmaster", {
                method: "POST",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(mainObj2)
            })
            const respdata = await resp.json()
            const resp2 = await fetch("https://masterpg.9xxbet.com/api/v1/master/addmaster", {
                method: "POST",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(mainObj2)
            })
            const respdata2 = await resp2.json()
            if (respdata.status === 'success') {
                toast.success("Market added to our server postgrey.")
            } else {
                toast.error(respdata.message)
            }
            const addto = []
            addto.push(mainObject)
            const raw = JSON.stringify(addto);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status) {
                        toast.success("Market added to our server park.")
                    } else {
                        toast.error("Market is not added")
                    }
                })
                .catch(error => {
                    toast.error("Server Error 500")
                    console.log('error', error)
                });
        }
    }

    const [tossMarket, setTossMarket] = useState({
        marketname: "Match Odds",
        eventId: "",
        sel1: "",
        sel2: "",
        stEventName: "",
        spid: "",
    })

    const onTChange = (e) => {
        setTossMarket({
            ...tossMarket, [e.target.name]: e.target.value
        })
    }

    const addTossMarket = async (element) => {
        var date = document.getElementById('new-date').value
        var time = document.getElementById('time-start').value
        var startDate = date + " " + time + ":00"
        var randomID = parseInt(makeRandom(4));
        var randomID1 = parseInt(makeRandom(6));
        var randomID2 = parseInt(makeRandom(6));
        const addto = []
        const mainObj2 = {
            bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: '58965896', eventId: (tossMarket.eventId).toString(), eventTypeId: tossMarket.spid === '12' ? 12 : 4, inplay: true, key: "MARKET:" + "1.47" + randomID,
            marketId: "1.47" + randomID, marketName: tossMarket.marketname, marketStatus: 'OPEN', marketSuspendTime: new Date(startDate), marketTime: new Date(startDate), marketType: "Match Odds", numberOfRunners: 2,
            productType: "EXCHANGE", runners: [
                {
                    stInstrumentID: "1.47" + randomID + "_" + parseInt(randomID1),
                    marketId: "1.47" + randomID,
                    runnerName: tossMarket.sel1,
                    selectionId: randomID1.toString()
                },
                {
                    stInstrumentID: "1.47" + randomID + "_" + parseInt(randomID2),
                    marketId: "1.47" + randomID,
                    runnerName: tossMarket.sel2,
                    selectionId: randomID2.toString()
                }
            ], totalAvailable: 0, totalMatched: 0, eventName: tossMarket.stEventName, competitionName: "CUSTOM", eventTypeName: tossMarket.spid === '12' ? "Politics" : "Cricket"
        }
        const resp = await fetch("https://webapi.demoxyzapi.com/api/v1/master/addmaster", {
            method: "POST",
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(mainObj2)
        })
        const respdata = await resp.json()
        const resp2 = await fetch("https://masterpg.9xxbet.com/api/v1/master/addmaster", {
            method: "POST",
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(mainObj2)
        })
        const respdata2 = await resp2.json()
        if (respdata.status === 'success') {
            toast.success("Market added to our server postgrey.")
        } else {
            toast.error(respdata.message)
        }
        const mainObject = {
            "btMarketStatus": 0,
            "dtStartDate": new Date(startDate).toLocaleString(),
            // "dtStartDate": new Date(element.marketTime).toLocaleString(),
            "stCompititionID": '58965896',
            "stCompititionName": 'CUSTOM',
            "stEventID": (tossMarket.eventId).toString(),
            "stEventName": tossMarket.stEventName,
            "stMarketID": "1.47" + randomID,
            "stMarketName": tossMarket.marketname,
            "stSportsID": tossMarket.spid === '12' ? "12" : "4",
            "stSportsName": tossMarket.spid === '12' ? "Politics" : "Cricket",
            "submaster": [
                {
                    stInstrumentID: "1.47" + randomID + "_" + randomID1,
                    stMarketID: "1.47" + randomID,
                    stRunnerName: tossMarket.sel1,
                    stSelectionID: randomID1.toString()
                },
                {
                    stInstrumentID: "1.47" + randomID + "_" + randomID2,
                    stMarketID: "1.47" + randomID,
                    stRunnerName: tossMarket.sel2,
                    stSelectionID: randomID2.toString()
                }
            ]
        }
        addto.push(mainObject)
        const raw = JSON.stringify(addto);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://masterapi.fun4club.com/api/admin/postmaster", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status) {
                    toast.success("Market added to our server park.")
                } else {
                    toast.error("Market is not added")
                }
            })
            .catch(error => {
                toast.error("Server Error 500")
                console.log('error', error)
            });
    }

    const [file, setFile] = useState(null);

    const addScoreKey = async () => {
        let doc = document.getElementById('scorekey')
        if (doc) {
            const res = await fetch('https://nodebb.radhe99.com/api/score/updatekey?key=' + doc.value)
            const resData = await res.json()
            if (resData.status === 'success') {
                toast.success("Key add.")
            }
        }
    }
    const addHorseKey = async () => {
        let doc = document.getElementById('horsekey')
        if (doc) {
            const res = await fetch('https://mas.9xxbet.com/api/master/addhorsekey?key=' + doc.value)
            const resData = await res.json()
            if (resData.status === 'success') {
                toast.success("Key add.")
            }
        }
    }

    const handleFileChange = (e) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };

    const addPosterToPG = async () => {
        if (!file)
            toast.error('Please Attach image')
        else {
            const formData = new FormData();
            formData.append("file", file);
            const res = await fetch('https://webapi.demoxyzapi.com/api/v1/users/addposter', {
                method: "POST",
                body: formData
            })
            const data = await res.json()
            if (data.status === 'success') {
                toast.success('Image uploaded.')
            }
        }
    }

    return (
        <>
            <header _ngcontent-cts-c46="" class="login-header">
                <app-topnav _ngcontent-cts-c46="" _nghost-cts-c43="">
                    <nav _ngcontent-cts-c43="" class=" justify-content-between col-lg-12 col-12 p-0 d-flex flex-row">
                        <div _ngcontent-cts-c43="" class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                            <button id='sidebar-btn' onClick={() => { openSideBar() }} style={{ color: "white" }} _ngcontent-gdi-c43="" type="button" data-toggle="minimize" class="navbar-toggler navbar-toggler align-self-center d-lg-none">
                                <span _ngcontent-gdi-c43="" class="fa fa-navicon"></span>
                            </button>
                            {/* <a style={{ color: "white", display: 'contents' }} _ngcontent-cts-c43="" onClick={() => { navigate("/") }} class="navbar-brand brand-logo">
                                <span>FANCY</span>
                            </a> */}
                        </div>
                        <div _ngcontent-cts-c43="" class="navbar-menu-wrapper d-flex align-items-stretch">
                            {/* {
                                SessionUser !== null && SessionUser &&
                                <ul style={{ marginRight: "10px" }} _ngcontent-cts-c43="" class="navbar-nav navbar-nav-right sign-in-nav">
                                    <li _ngcontent-cts-c43="" class="nav-item">
                                        <button onClick={() => {navigate('/trades')}} class="btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn-login">1</button>
                                        <button onClick={() => {navigate('/trades2')}} class="btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn-login">2</button>
                                    </li>
                                </ul>
                            } */}
                            <div _ngcontent-cts-c43="" class="search-field d-none">
                                <form _ngcontent-cts-c43="" novalidate="" action="#" class="d-flex align-items-center h-100 ng-untouched ng-pristine ng-valid">
                                    <div _ngcontent-cts-c43="" class="input-group">
                                        <div _ngcontent-cts-c43="" class="input-group-prepend bg-transparent">
                                            <i _ngcontent-cts-c43="" class="input-group-text border-0 mdi mdi-magnify"></i>
                                        </div>
                                        <input _ngcontent-cts-c43="" type="text" placeholder="Search projects" class="form-control bg-transparent border-0" />
                                    </div>
                                </form>
                            </div>
                            {
                                SessionUser !== null && SessionUser ? (
                                    <div className='m-2' >
                                        <div class="d-flex gap-1">
                                            <div class="dropdown">
                                                <a href="#" role="button" data-bs-toggle="dropdown" aria-expanded="true" class="btn btn-login dropdown-toggle">
                                                    <i class="fa-solid fa-user"></i>
                                                    <span class="ps-1 d-lg-inline d-none">{SessionUser.UserName}</span>
                                                </a>
                                                <ul id='dropdown' class="dropdown-menu dropdown-menu-end" data-bs-popper="static">
                                                    {/* <li class="text-center border-bottom fw-semibold">
                                                        <i class="fa-solid fa-user"></i>
                                                        <span class="ps-1 d-lg-inline">{SessionUser.UserName}</span>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#rollback-popup">RollBack market</a>
                                                    </li>
                                                    <li>
                                                        <NavLink to={'/trades'} class="dropdown-item a" >Pending Results</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink to={'/trades2'} class="dropdown-item a" >Pending Results Server 2</NavLink>
                                                    </li>
                                                    <li >
                                                        <NavLink to={'/fancy'} class="dropdown-item a"  >All Fancy Market</NavLink>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-key-election">Add election EventId</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-radhe-fancy-new">Add Radhe Fancy New</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-key-fancy">Add EventId</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#remove-key-fancy">Remove EventId</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-bookmaker-sky">Add BookMaker Sky</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#manual-toss-market">Add MatchOdds Custom</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-bookmaker-win">Add BookMaker Custom</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-bookmaker-win-p">Add BookMaker Premium</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-fancy-popup-cbtf">Add Fancy</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-common-banner">Add Common Banner</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-score-key">Add Score Key</a>
                                                    </li>
                                                    <li >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-horse-key">Add Horse Key</a>
                                                    </li>
                                                   <li onClick={() => {
                                                        setData({
                                                            eid: "",
                                                            link: ""
                                                        })
                                                    }} >
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#add-link">Add Link</a>
                                                    </li>
                                                    <li data-bs-toggle="modal" data-bs-target="#add-fancy-popup-auto4">Add Election Fancy</li>
                                                    */}
                                                    <li class="px-1">
                                                        <NavLink class="dropdown-item" to='/' fdprocessedid="x3fp1">Result</NavLink>
                                                    </li>
                                                    <li class="px-1">
                                                        <NavLink class="dropdown-item" to='/history' fdprocessedid="x3fp1">History</NavLink>
                                                    </li>
                                                    <li class="px-1">
                                                        <button class="btn w-100 btn-login" onClick={logoutUser} fdprocessedid="x3fp1">Logout</button>
                                                    </li>
                                                </ul>
                                            </div>
                                            {/* <div class="dropdown">
                                                <a href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false" class="balance btn btn-login dropdown-toggle">
                                                    <i class="fa-solid fa-coins"></i> {parseFloat(balanceData?.deBalance).toFixed(2)} </a>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                   
                                                </ul>
                                            </div> */}
                                        </div>
                                        {/* <div class="text-end small">
                                            <a onClick={getUserExpozure} style={{ color: "white" }} data-bs-toggle="modal" data-bs-target="#exposurePopup">
                                                <span style={{ padding: "0 2px" }}>{SessionUser.UserName}</span>
                                                <span class="pe-2"> EXP :</span>
                                                <span className='exp-c'>{parseFloat(balanceData?.deLiability + balanceData?.deRisk).toFixed(2)}</span>
                                            </a>
                                        </div> */}
                                    </div>
                                ) : (
                                    <ul style={{ marginRight: "10px" }} _ngcontent-cts-c43="" class="navbar-nav navbar-nav-right sign-in-nav">
                                        <li _ngcontent-cts-c43="" class="nav-item">
                                            <button onClick={() => {
                                                dispatch(openLoginModal())
                                            }} _ngcontent-cts-c43="" class="btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn-login">sign in</button>
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                    </nav>
                </app-topnav>
            </header>
            <div id="add-key-fancy" tabindex="-1" aria-labelledby="rollback-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add fancy key</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">Key</label>
                                    <input className='form-control' placeholder='please enter key here' type="text" id='exidadd' name='marketname' />
                                </div>
                            </form>
                            <button data-bs-dismiss='modal' onClick={() => {
                                addExEventID()
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="add-score-key" tabindex="-1" aria-labelledby="rollback-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add Score key</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">Key</label>
                                    <input className='form-control' placeholder='please enter key here' type="text" id='scorekey' name='scorekey' />
                                </div>
                            </form>
                            <button data-bs-dismiss='modal' onClick={() => {
                                addScoreKey()
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="add-horse-key" tabindex="-1" aria-labelledby="rollback-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add Horse key</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">Horse Key</label>
                                    <input className='form-control' placeholder='please enter key here' type="text" id='horsekey' name='horsekey' />
                                </div>
                            </form>
                            <button data-bs-dismiss='modal' onClick={() => {
                                addHorseKey()
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="add-key-election" tabindex="-1" aria-labelledby="rollback-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add election key</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">Key</label>
                                    <input className='form-control' placeholder='please enter key here' type="text" id='exideladd' name='marketname' />
                                </div>
                            </form>
                            <button data-bs-dismiss='modal' onClick={() => {
                                addExEventIDElection()
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="add-fancy-popup-auto4" class="modal fade " aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add Manual Election bellow</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div className='d-flex flex-column'>
                                    <label htmlFor="">Enter MarketName below</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onMChange} value={addFancyModal.marketname} name='marketname' />
                                </div>
                                <div className='d-flex flex-column'>
                                    <label htmlFor="">Enter EventId</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onMChange} value={addFancyModal.eventId} name='eventId' />
                                </div>
                                <div className='d-flex flex-column'>
                                    <label htmlFor="">Enter EventName</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onMChange} value={addFancyModal.eventName} name='eventName' />
                                </div>
                                <div class="form-floating my-3">
                                    <select onChange={(e) => selectChange(e)} class="form-select" id="floatingSelect" aria-label="Floating label select example">
                                        <option disabled selected>Select from below</option>
                                        <option value="FMN">FMN</option>
                                        <option value="FWPN">FWPN</option>
                                        <option value="FMTON">FMTON</option>
                                    </select>
                                    <label for="floatingSelect">select market type</label>
                                </div>
                            </form>
                            <button onClick={() => {
                                addMarketToDataBase()
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade " id="add-bookmaker-id" tabindex="-1" role="dialog" style={{ display: "none" }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Add BookMaker ID</h5>
                            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="form-group">
                                    <label for="eventid">MarketID</label>
                                    <input onChange={changeBookData} name='eid' value={bookData.eid} type="text" class="form-control" id="eventid" placeholder="MarketId Main" />
                                    {/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                </div>
                                <div class="form-group">
                                    <label for="linktv">World MI</label>
                                    <input onChange={changeBookData} name='link' value={bookData.link} type="text" class="form-control" placeholder='World Mid' />
                                </div>
                                <div class="form-check">
                                    {/* <input type="checkbox" class="form-check-input" id="exampleCheck1" /> */}
                                    {/* <label class="form-check-label" for="exampleCheck1">Check me out</label> */}
                                </div>
                                <button data-bs-dismiss="modal" onClick={() => {
                                    addBookId()
                                }} type="button" class="btn btn-primary">Submit</button>
                            </form>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            {/* <button type="button" class="btn btn-primary">Save changes</button> */}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade " id="add-bookmaker" tabindex="-1" role="dialog" style={{ display: "none" }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Add BookMaker ID</h5>
                            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="form-group">
                                    <label for="eventid">MarketID</label>
                                    <input onChange={changeBookData} name='eid' value={bookData.eid} type="text" class="form-control" id="eventid" placeholder="MarketId Main" />
                                    {/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                </div>
                                <div class="form-group">
                                    <label for="linktv">Key</label>
                                    <input onChange={changeBookData} name='link' value={bookData.link} type="text" class="form-control" placeholder='Auth key' />
                                </div>
                                <div class="form-group">
                                    <label for="linktv">Cockie</label>
                                    <input onChange={changeBookData} name='cockie' value={bookData.cockie} type="text" class="form-control" placeholder='Enter full cockie' />
                                </div>
                                <div class="form-check">
                                    {/* <input type="checkbox" class="form-check-input" id="exampleCheck1" /> */}
                                    {/* <label class="form-check-label" for="exampleCheck1">Check me out</label> */}
                                </div>
                                <button data-bs-dismiss="modal" onClick={() => {
                                    addFullBook()
                                }} type="button" class="btn btn-primary">Submit</button>
                            </form>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            {/* <button type="button" class="btn btn-primary">Save changes</button> */}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade " id="delete-bookmaker-id" tabindex="-1" role="dialog" style={{ display: "none" }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Delete BookMaker ID</h5>
                            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="form-group">
                                    <label for="eventid">MarketID</label>
                                    <input onChange={changeBookData} name='eid' value={bookData.eid} type="text" class="form-control" id="eventid" placeholder="MarketId Main" />
                                    {/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                </div>
                                <div class="form-check">
                                    {/* <input type="checkbox" class="form-check-input" id="exampleCheck1" /> */}
                                    {/* <label class="form-check-label" for="exampleCheck1">Check me out</label> */}
                                </div>
                                <button data-bs-dismiss="modal" onClick={() => {
                                    deleteBookId()
                                }} type="button" class="btn btn-primary">Submit</button>
                            </form>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            {/* <button type="button" class="btn btn-primary">Save changes</button> */}
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade " id="add-link" tabindex="-1" role="dialog" style={{ display: "none" }} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Add Link</h5>
                            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="form-group">
                                    <label for="eventid">EventID</label>
                                    <input onChange={changeData} name='eid' value={data.eid} type="number" class="form-control" id="eventid" placeholder="EventId" />
                                    {/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                </div>
                                <div class="form-group">
                                    <label for="linktv">Link</label>
                                    <input onChange={changeData} name='link' value={data.link} type="text" class="form-control" id="linktv" placeholder="tv-link" />
                                </div>
                                <div class="form-check">
                                    {/* <input type="checkbox" class="form-check-input" id="exampleCheck1" /> */}
                                    {/* <label class="form-check-label" for="exampleCheck1">Check me out</label> */}
                                </div>
                                <button data-bs-dismiss="modal" onClick={() => {
                                    addTvLink()
                                }} type="button" class="btn btn-primary">Submit</button>
                            </form>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            {/* <button type="button" class="btn btn-primary">Save changes</button> */}
                        </div>
                    </div>
                </div>
            </div>
            <div id="remove-key-fancy" tabindex="-1" aria-labelledby="rollback-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">remove fancy key</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">Key</label>
                                    <input className='form-control' placeholder='please enter key here' type="text" id='exidremove' name='marketname' />
                                </div>
                            </form>
                            <button data-bs-dismiss='modal' onClick={() => {
                                removeExId()
                            }} className='btn btn-success btn-lg'>Remove</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="add-bookmaker-sky" tabindex="-1" aria-labelledby="rollback-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add BookMaker Sky</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">EventId</label>
                                    <input className='form-control' placeholder='please enter key here' type="text" id='bookskyid' name='marketname' />
                                </div>
                            </form>
                            <button data-bs-dismiss='modal' onClick={() => {
                                addSkySportBookMaker()
                            }} className='btn btn-success btn-lg'>Add BookMaker</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="rollback-popup" tabindex="-1" aria-labelledby="rollback-popup" class="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        {
                            // loader ? (
                            //     <div>Loading...</div>
                            // ) : (
                            <>
                                <div class="modal-header text-dark">
                                    <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">RollBack Your MarketID</h1>
                                    <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                                </div>
                                <div class="modal-body">
                                    <div className='m-3 d-flex flex-column gap-1'>
                                        <label>Enter rollback marketId</label>
                                        <input autoFocus={true} className='form-control bs_stakes_i ng-untouched ng-pristine ng-valid' type="number" onChange={onResultDChange} value={resultData.mid} name='mid' />
                                    </div>
                                    <div className='d-flex m-2 gap-2 justify-content-center flex-wrap'>
                                        {/* <button onClick={() => {
                                            if (window.confirm('are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                if (window.confirm('again are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                    rollBackMidParker(resultData.mid).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                    })
                                                }
                                            }
                                        }} className='btn btn-danger'>RollBack Parker</button> */}
                                        <button onClick={() => {
                                            if (window.confirm('are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                if (window.confirm('again are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                    rollBackMidMaster(resultData.mid).then((data) => {
                                                        toast.success("Rollback successfully")
                                                    })
                                                }
                                            }
                                        }} className='btn btn-danger'>RollBack Master</button>
                                        {/* <button onClick={() => {
                                            if (window.confirm('are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                if (window.confirm('again are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                    rollBackMidFox(resultData.mid).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                    })
                                                }
                                            }
                                        }} className='btn btn-danger'>RollBack Fox</button> */}
                                        {/* <button onClick={() => {
                                            if (window.confirm('are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                if (window.confirm('again are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                    rollBackMidShree(resultData.mid).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                    })
                                                }
                                            }
                                        }} className='btn btn-danger'>RollBack Shree</button> */}
                                        <button onClick={() => {
                                            if (window.confirm('are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                if (window.confirm('again are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                    rollBackMidHero(resultData.mid).then((data) => {
                                                        if (data?.status === 'success') {
                                                            toast.success("Market RollBack")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                    })
                                                }
                                            }
                                        }} className='btn btn-danger'>RollBack Hero</button>
                                        <button onClick={() => {
                                            if (window.confirm('are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                if (window.confirm('again are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                    rollBackVelki(resultData.mid).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                    })
                                                }
                                            }
                                        }} className='btn btn-danger'>RollBack velki</button>
                                        {/* <button onClick={() => {
                                            if (window.confirm('are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                if (window.confirm('again are you sure you want to rallback this marketId = ' + resultData.mid)) {
                                                    rollBackMidAll(resultData.mid).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                    })
                                                }
                                            }
                                        }} className='btn btn-danger'>RollBack To All</button> */}
                                    </div>
                                </div>
                            </>
                            // )
                        }
                    </div>
                </div>
            </div>
            <div id='add-fancy-popup-cbtf' role="dialog" class="modal modal-fullscreen-sm-down fade " style={{ display: "none" }}>
                <div class="modal-dialog modal-fullscreen">
                    <div class="modal-content">
                        <div style={{ padding: "0 4px" }} class="modal-header">
                            <h1 class="modal-title fs-4" id="exampleModalFullscreenLabel">Add Fancy Markets</h1>
                            <button style={{ padding: "0 40px" }} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div style={{ padding: "8px" }} class="modal-body">
                            <div className='d-flex gap-3 py-3'>
                                <button onClick={() => {
                                    // getApiFancyList()
                                    getCbtfFancy(document.getElementById('exid9').value)
                                }} className='btn btn-primary'>Get Fancy List</button>
                                <input onChange={(e) => {
                                    setInpEvd(e.target.value)
                                }} className='form-control' value={inpEvd} id='exid9' type="text" />
                            </div>
                            <table className='table table-responsive table-bordered table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Event</th>
                                        <th>Market Name</th>
                                        <th>Market type</th>
                                        <th>Add</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cbtfFancyList?.map((a) => (
                                            <tr>
                                                <>
                                                    <td>{a.eventName}</td>
                                                    <td>{a.name}</td>
                                                    <td>{a.marketType}</td>
                                                    <td>
                                                        <select name="" id={"ftype_" + a.marketId}>
                                                            <option selected disabled value="0">Select from below</option>
                                                            <option value="FM">FM</option>
                                                            <option value="FWP">FWP</option>
                                                            <option value="FMTO">FMTO</option>
                                                        </select>
                                                    </td>
                                                    <td><button onClick={() => {
                                                        addFancyApi(a)
                                                    }} className='btn btn-primary'>Add fancy</button></td>
                                                </>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id='add-radhe-fancy-new' role="dialog" class="modal modal-fullscreen-sm-down fade " style={{ display: "none" }}>
                <div class="modal-dialog modal-fullscreen">
                    <div class="modal-content">
                        <div style={{ padding: "0 4px" }} class="modal-header">
                            <h1 class="modal-title fs-4" id="exampleModalFullscreenLabel">Add Fancy Markets</h1>
                            <button style={{ padding: "0 40px" }} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div style={{ padding: "8px" }} class="modal-body">
                            <div className='d-flex gap-3 py-3'>
                                <button onClick={() => {
                                    let eid = document.getElementById('radhe-eid').value
                                    let tk = document.getElementById('radhe-tk').value
                                    getApiFancyListRadhe(eid, tk)
                                }} className='btn btn-primary'>Get Fancy List</button>
                                <input className='form-control' id='radhe-eid' type="text" />
                                <input className='form-control' id='radhe-tk' type="text" />
                            </div>
                            <table className='table table-responsive table-bordered table-striped table-hover'>
                                <thead>
                                    <tr>
                                        {/* <th>Event</th> */}
                                        <th>Market Name</th>
                                        <th>Market type</th>
                                        <th>Add</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        radhefancy?.map((a) => (
                                            <tr>
                                                <>
                                                    {/* <td>{a.eventName}</td> */}
                                                    <td>{a.fancyName}</td>
                                                    <td>{a.competitionName}</td>
                                                    <td>
                                                        <select name="" id={"radheftype_" + a.marketId}>
                                                            <option selected disabled value="0">Select from below</option>
                                                            <option value="FM">FM</option>
                                                            <option value="FWP">FWP</option>
                                                            <option value="FMTO">FMTO</option>
                                                        </select>
                                                    </td>
                                                    <td><button onClick={() => {
                                                        addFancyApiradhe(a)
                                                    }} className='btn btn-primary'>Add fancy</button></td>
                                                </>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id='add-bookmaker-win' role="dialog" class="modal modal-fullscreen-sm-down fade " style={{ display: "none" }}>
                <div class="modal-dialog modal-fullscreen">
                    <div class="modal-content">
                        <div style={{ padding: "0 4px" }} class="modal-header">
                            <h1 class="modal-title fs-4" id="exampleModalFullscreenLabel">Add </h1>
                            <button style={{ padding: "0 40px" }} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div style={{ padding: "8px" }} class="modal-body">
                            <div className='d-flex gap-3 py-3'>
                                <button onClick={() => {
                                    getWinnerList(document.getElementById('exwid').value)
                                }} className='btn btn-primary'>Get Fancy List</button>
                                <input className='form-control' id='exwid' type="text" />
                            </div>
                            <table className='table table-responsive table-bordered table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Event</th>
                                        <th>Market Name</th>
                                        <th>Market type</th>
                                        <th>Event ID</th>
                                        <th>Add</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        winnerMarkets?.data?.map((a) => (
                                            <tr>
                                                <td>{a.eventName}</td>
                                                <td>{a.name}</td>
                                                <td>{a.runners?.length}</td>
                                                <td>
                                                    <input type="text" id={"winner" + a.betfairId} className="form-control" />
                                                </td>
                                                <td>
                                                    <button onClick={() => { addWinnerBookMaker(a) }} className="btn-primary btn-sm">
                                                        Add
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id='add-bookmaker-win-p' role="dialog" class="modal modal-fullscreen-sm-down fade " style={{ display: "none" }}>
                <div class="modal-dialog modal-fullscreen">
                    <div class="modal-content">
                        <div style={{ padding: "0 4px" }} class="modal-header">
                            <h1 class="modal-title fs-4" id="exampleModalFullscreenLabel">Add Premium</h1>
                            <button style={{ padding: "0 40px" }} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div style={{ padding: "8px" }} class="modal-body">
                            <div className='d-flex gap-3 py-3'>
                                <button onClick={() => {
                                    getWinnerListP(document.getElementById('exwidp').value)
                                }} className='btn btn-primary'>Get Fancy List</button>
                                <input className='form-control' id='exwidp' type="text" />
                            </div>
                            <table className='table table-responsive table-bordered table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Event</th>
                                        <th>Market Name</th>
                                        <th>Runner Count</th>
                                        <th>Event ID</th>
                                        <th>Add</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        winnerMarkets?.data?.map((a) => (
                                            <tr>
                                                <td>{a.eventName}</td>
                                                <td>{a.name}</td>
                                                <td>{a.runner?.length}</td>
                                                <td>
                                                    <button onClick={() => { addWinnerBookMakerP(a) }} className="btn-primary btn-sm">
                                                        Add
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="manual-toss-market" class="modal fade " aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add Toss Market bellow</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">MarketName</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onTChange} value={tossMarket.marketname} name='marketname' />
                                </div>
                                <div>
                                    <label htmlFor="">EventName</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onTChange} value={tossMarket.stEventName} name='stEventName' />
                                </div>
                                <div>
                                    <label htmlFor="">EventId</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onTChange} value={tossMarket.eventId} name='eventId' />
                                </div>
                                <div>
                                    <label htmlFor="">SportsId</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onTChange} value={tossMarket.spid} name='spid' />
                                </div>
                                <div>
                                    <label htmlFor="">DateTime</label>
                                    <input id='new-date' type="date" className="form-control rounded-0 text-uppercase ng-untouched ng-pristine ng-valid" />
                                    <div class="cs-form">
                                        <input type="time" id='time-start' className='form-control' />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="">Selection 1</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onTChange} value={tossMarket.sel1} name='sel1' />
                                </div>
                                <div>
                                    <label htmlFor="">Selection 2</label>
                                    <input className='form-control' placeholder='please enter marketname here' type="text" onChange={onTChange} value={tossMarket.sel2} name='sel2' />
                                </div>
                            </form>
                            <button onClick={() => {
                                addTossMarket()
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="add-common-banner" class="modal fade " aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header text-dark">
                            <h1 id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add Toss Market bellow</h1>
                            <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">Image</label>
                                    <input className='form-control' onChange={handleFileChange} placeholder='please enter marketname here' type="file" name='sel2' />
                                </div>
                            </form>
                            <button onClick={() => {
                                addPosterToPG()
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
